import React, { useEffect, useState } from "react";
import DeviceContext from "./customHooks/indentifyDevice";
const SearchBar = (props) => {
    const device = DeviceContext();
    const [openSearch, setOpenSearch] = useState((props === null || props === void 0 ? void 0 : props.focusOnLoad) ? props === null || props === void 0 ? void 0 : props.focusOnLoad : false);
    const [searchValue, setSearchValue] = useState((props === null || props === void 0 ? void 0 : props.defaultValue) ? props === null || props === void 0 ? void 0 : props.defaultValue : "");
    // useEffect(() => {
    //   if (props.onCallbackFunction ) {
    //     props.onCallbackFunction(searchValue);
    //   }
    // }, [searchValue, props.defaultValue]);
    useEffect(() => {
        if (props.onCallbackFunction) {
            props.onCallbackFunction(searchValue);
        }
    }, [searchValue]);
    return (React.createElement("div", { className: props.parentClassName ? props.parentClassName : "" },
        React.createElement("div", { className: `common-search-bar d-flex align-items-center ${props.searchBarBackground} ${openSearch && "open-search"}` },
            openSearch ? (React.createElement("label", { htmlFor: "focus-input", onMouseDown: () => {
                    (props === null || props === void 0 ? void 0 : props.onBack) && props.onBack();
                } },
                React.createElement("span", { className: "edel-icon-left-arrow " }))) : (React.createElement("label", null,
                React.createElement("i", { className: "edel-icon-search1", onClick: () => {
                        if (props === null || props === void 0 ? void 0 : props.disabled)
                            return;
                        setOpenSearch(true);
                    } }))),
            React.createElement("input", { autoFocus: props === null || props === void 0 ? void 0 : props.focusOnLoad, autoComplete: props === null || props === void 0 ? void 0 : props.autoComplete, disabled: props === null || props === void 0 ? void 0 : props.disabled, className: openSearch ? props.openInputBackground : props.searchBarBackground, id: "focus-input", type: "search", placeholder: (device === null || device === void 0 ? void 0 : device.isDesktop) ? props.deskPlaceHolder : props.mobPlaceHolder, value: searchValue, onFocus: () => setOpenSearch(true), onChange: (e) => setSearchValue(e.target.value), onBlur: () => {
                    if (!searchValue) {
                        setSearchValue("");
                        setOpenSearch(false);
                        props === null || props === void 0 ? void 0 : props.onBack();
                    }
                } }),
            openSearch && (React.createElement("label", { htmlFor: "focus-input" },
                React.createElement("i", { className: "edel-icon-close txt_secondary-gray hand_cursor", onClick: () => setSearchValue("") }))))));
};
export default SearchBar;
